import API, { AUTH_HEADER, GET_AUTH } from 'base/api';
export const FETCH_ALL_ROOMS = 'FETCH_ALL_ROOMS';
export const FETCH_ALL_ROOMS_BEGIN = 'FETCH_ALL_ROOMS_BEGIN';
export const FETCH_ALL_ROOMS_SUCCESS = 'FETCH_ALL_ROOMS_SUCCESS';
export const FETCH_ALL_ROOMS_ERROR = 'FETCH_ALL_ROOMS_ERROR';

export const fetchAllRoomsBegin = () => ({
  type: FETCH_ALL_ROOMS_BEGIN
});

export const fetchAllRoomsSuccess = ( data ) => ({
  type: FETCH_ALL_ROOMS_SUCCESS,
  payload: { data }
});

export const fetchAllRoomsError = ( error ) => ({
  type: FETCH_ALL_ROOMS_ERROR,
  payload: { error }
});

export function fetchAllRooms (){
  return dispatch => {
    dispatch(fetchAllRoomsBegin());
    return fetch(API.GET_ROOMS, GET_AUTH)
      .then(handleErrors)
      .then(res => res.json())
      .then(json => {
        dispatch(fetchAllRoomsSuccess(json));
        return json;
      })
      .catch(error => dispatch(fetchAllRoomsError(error.message)));
  };
}

function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}


// WEBPACK FOOTER //
// ./src/modules/Admin/redux/actions/getRooms.js